import { getItem, setItem } from '@/utils/storage'
import Vue from 'vue'
import Vuex from 'vuex'
import { login } from '@/api/home'
import { Toast } from 'vant'
import router from '@/router'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    token: getItem('token') || '',
    userInfo: getItem('userInfo') || {}
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      setItem('token', token)
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  },
  actions: {
    login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((response) => {
            if (response.data.code == 200) {
              const { data } = response.data

              commit('setUserInfo', data)

              Toast.success('登录成功')
              router.push({
                path: '/'
              })
              resolve()
            } else {
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
})
